// extracted by mini-css-extract-plugin
export default {"btop":"f96519e745 _13fcb484a8 _9622700802","icon":"cfc72910e0 bc759ed909","btoppink":"_6d438c59d6 _5c47e0001e"};